import React from 'react'

function WantToDiscuss() {
  return (
    <>
      <section className="want-to-discuss" id="">
        <div className="row ">
          <div className="container">
            <div className="free-solt">
              <div className="video-pop wow fadeInLeft">
                <div className="video-title">
                  <p className="getting">
                    <span className="discuss">
                      Want to discuss ideas for your Snapshot Videos?
                    </span>
                    <span className="give-us">
                      Give us a call now:{" "}
                      <a href="tel:(800) 820-6020">(800) 820-6020</a>.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default WantToDiscuss;